import { ActionIcon, type ActionIconProps, Tooltip } from "@mantine/core"
import type { ComponentPropsWithoutRef } from "react"

export function AppActionIcon({
  children,
  label,
  ...props
}: ActionIconProps & { label?: string } & ComponentPropsWithoutRef<"button">) {
  return (
    <Tooltip label={label} disabled={!label}>
      <ActionIcon size="lg" radius="lg" variant="light" {...props}>
        {children}
      </ActionIcon>
    </Tooltip>
  )
}
